import { graphql, useStaticQuery } from 'gatsby'
import { FC } from 'react'

import Container from '../../../components/Container'
import { ButtonStyled } from '../../../components/common/Button/styles'
import { buildQueryParam } from '../../../helpers'
import { useIntlLabel } from '../../../intl'
import { ServicePresSection } from './__generated__/ServicePresSection'
import { ContentWrapperStyled, DescriptionStyled, SectionStyled, titleStyle } from './_styles'

interface ServicePresSectionProps {
    sectionTitle?: string | null
    sectionDescription?: string | null
    goBack?: boolean
    categorySlug?: string | null
    personaSlug?: string | null
    component?: 'h2' | 'h4'
}

const ServicePresSectionPage: FC<ServicePresSectionProps> = ({
    sectionTitle,
    sectionDescription,
    categorySlug,
    personaSlug,
    component = 'h2',
    goBack,
}) => {
    const getIntlLabel = useIntlLabel()

    const { strapiServiceSection, strapiGlobal } = useStaticQuery<ServicePresSection>(
        graphql`
            query ServicePresSection {
                strapiServiceSection {
                    sectionTitle_mg
                    sectionTitle
                    sectionDescription
                    sectionDescription_mg
                }
                strapiGlobal {
                    serviceBackToListLabel
                    serviceBackToListLabel_mg
                }
            }
        `,
    )

    return (
        <SectionStyled>
            <Container>
                <ContentWrapperStyled>
                    {component === 'h2' && (
                        <h2 css={titleStyle}>
                            {sectionTitle ?? getIntlLabel(strapiServiceSection, 'sectionTitle')}
                        </h2>
                    )}
                    {component === 'h4' && (
                        <h4 css={titleStyle}>
                            {sectionTitle ?? getIntlLabel(strapiServiceSection, 'sectionTitle')}
                        </h4>
                    )}
                    <DescriptionStyled>
                        {sectionDescription ??
                            getIntlLabel(strapiServiceSection, 'sectionDescription')}
                    </DescriptionStyled>
                    {goBack && (
                        <ButtonStyled
                            href={`/services/${categorySlug ?? ''}${buildQueryParam({
                                persona: personaSlug,
                            })}`}
                            type="button"
                            color={'primary'}
                        >
                            {getIntlLabel(strapiGlobal, 'serviceBackToListLabel')}
                        </ButtonStyled>
                    )}
                </ContentWrapperStyled>
            </Container>
        </SectionStyled>
    )
}

export default ServicePresSectionPage
